// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import {
  ArrowRightIcon,
  AwardIcon,
  BookOpenIcon,
  CheckIcon,
  CodeIcon,
  CodeXmlIcon,
  LightbulbIcon,
  Link,
  React,
  StarIcon,
  UsersIcon,
  ZapIcon,
  jsxRuntime,
  motion,
} from "../vendor/runtime.js";
import { Navbar } from "../components/Navbar.jsx";
import { Seo } from "../components/Seo.jsx";
import { Button } from "../components/Button.jsx";
import { logo, navLogo } from "../assets.js";
import { Footer } from "../components/Footer.jsx";
const HomePage = () => {
  const { currentUser: a, loading: n } = useAuth(),
    [i, l] = React.useState({
      projects: 0,
      users: 0,
      completions: 0,
    }),
    [c, u] = React.useState(false),
    [m, f] = React.useState([
      {
        id: 1,
        name: "Yogi",
        role: "CSE Student",
        university: "Anna university",
        content:
          "This platform helped me find real-world projects to apply my coding skills. The AI assistant guided me through implementing complex features I wouldn't have figured out alone!",
      },
      {
        id: 2,
        name: "Priya",
        role: "Engineering Student",
        university: "MIT",
        content:
          "As a busy student, I needed a platform that not only offered projects but explained how to approach them. The learning materials here are exceptional and helped me land an internship.",
      },
      {
        id: 3,
        name: "Vignesh",
        role: "Engineering Student",
        university: "MEC",
        content:
          "I had a startup idea but no technical skills. This marketplace connected me with talented CS students who understood my vision, and the interactive learning helped me communicate my ideas better.",
      },
    ]);
  React.useEffect(() => {
    (async () => {
      try {
        (l({
          projects: 150,
          users: 250,
          completions: 400,
        }),
          u(true));
      } catch (b) {
        console.error("Error fetching data:", b);
      }
    })();
  }, []);
  const x = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
        },
      },
    },
    p = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.2,
        },
      },
    };
  return (
    <div className={"min-h-screen bg-slate-50"}>
      <Navbar />
      <Seo />
      <section className={"relative overflow-hidden pt-25 sm:pt-30 pb-16 sm:pb-32"}>
        <div className={"absolute inset-0 z-0 opacity-10"}>
          <div
            className={
              "absolute w-48 sm:w-96 h-48 sm:h-96 bg-purple-300 rounded-full -top-10 sm:-top-20 -left-10 sm:-left-20 animate-blob"
            }
          />
          <div
            className={
              "absolute w-48 sm:w-96 h-48 sm:h-96 bg-indigo-300 rounded-full top-20 sm:top-40 right-10 sm:right-20 animate-blob animation-delay-2000"
            }
          />
          <div
            className={
              "absolute w-40 sm:w-80 h-40 sm:h-80 bg-blue-300 rounded-full bottom-10 sm:bottom-20 left-20 sm:left-40 animate-blob animation-delay-4000"
            }
          />
        </div>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16 relative z-10"}>
          <div className={"flex flex-col lg:flex-row items-center gap-8 lg:gap-16"}>
            <motion.div
              className={"w-full lg:w-1/2 text-center lg:text-left"}
              initial={"hidden"}
              animate={"visible"}
              variants={x}
            >
              <span
                className={
                  "inline-block py-1 px-3 sm:px-4 mb-4 sm:mb-6 bg-indigo-100 text-indigo-800 rounded-full font-medium text-xs sm:text-sm text-center"
                }
              >
                {"For College Students, By College Students"}
              </span>
              <h1
                className={
                  "text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold leading-tight mb-3 sm:mb-6 text-center lg:text-left"
                }
              >
                {"Projects So Easy, Even Your"}{" "}
                <span
                  className={
                    "bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent"
                  }
                >
                  {" "}
                  {"Lazy Friend"}{" "}
                </span>{" "}
                {"Can Do It."}
              </h1>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 mb-4 sm:mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed text-justify"
                }
              >
                {
                  "Buy ready-made academic projects and get full AI-powered explanations – from code to concept. Our smart tutor breaks it down step by step, so you learn while you submit."
                }
              </p>
              <div className={"flex flex-wrap gap-3 sm:gap-4 justify-center lg:justify-start"}>
                {a ? (
                  <Link to={"/projects"}>
                    <Button
                      variant={"primary"}
                      className={
                        "group px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg rounded-xl font-medium bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white shadow-lg hover:shadow-indigo-200 transition duration-300"
                      }
                    >
                      {"Browse Projects"}
                      <ArrowRightIcon
                        className={
                          "inline-block ml-2 h-4 sm:h-5 w-4 sm:w-5 group-hover:translate-x-1 transition-transform"
                        }
                      />
                    </Button>
                  </Link>
                ) : (
                  <jsxRuntime.Fragment>
                    <Link to={"/login"}>
                      <Button
                        variant={"primary"}
                        className={
                          "group px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base rounded-xl font-medium bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white shadow-lg hover:shadow-indigo-200 transition duration-300"
                        }
                      >
                        {"Start Your Journey"}
                        <ArrowRightIcon
                          className={
                            "inline-block ml-1 sm:ml-2 h-3 sm:h-4 w-3 sm:w-4 group-hover:translate-x-1 transition-transform"
                          }
                        />
                      </Button>
                    </Link>
                  </jsxRuntime.Fragment>
                )}
              </div>
            </motion.div>
            <motion.div
              className={"w-full lg:w-1/2 relative px-4 sm:px-0"}
              initial={"hidden"}
              animate={"visible"}
              variants={x}
              transition={{
                delay: 0.2,
              }}
            >
              <div className={"relative z-10"}>
                <img
                  src={navLogo}
                  srcSet={`${navLogo} 400w, ${logo} 800w`}
                  sizes={"(max-width: 640px) 100vw, 800px"}
                  alt={"codebruh final year projects"}
                  className={"w-full h-auto rounded-2xl max-w-sm sm:max-w-none mx-auto"}
                  fetchPriority={"high"}
                />
                <motion.div
                  className={
                    "absolute -left-4 sm:-left-10 top-10 sm:top-20 bg-white p-2 sm:p-4 rounded-lg shadow-xl"
                  }
                  animate={{
                    y: [0, -10, 0],
                    rotate: [-1, 1, -1],
                  }}
                  transition={{
                    repeat: 1 / 0,
                    duration: 5,
                    ease: "easeInOut",
                  }}
                >
                  <div className={"flex items-center gap-2 sm:gap-3"}>
                    <div
                      className={
                        "w-8 sm:w-10 h-8 sm:h-10 bg-green-100 rounded-full flex items-center justify-center"
                      }
                    >
                      <AwardIcon className={"w-4 sm:w-5 h-4 sm:h-5 text-green-600"} />
                    </div>
                    <div>
                      <p className={"text-xs text-slate-400"}>{"Project"}</p>
                      <p className={"font-medium text-xs sm:text-sm"}>{"completed"}</p>
                    </div>
                  </div>
                </motion.div>
                <motion.div
                  className={
                    "absolute -right-3 sm:-right-6 -bottom-3 sm:-bottom-6 bg-white p-2 sm:p-4 rounded-lg shadow-xl"
                  }
                  animate={{
                    y: [0, 10, 0],
                    rotate: [1, -1, 1],
                  }}
                  transition={{
                    repeat: 1 / 0,
                    duration: 5,
                    ease: "easeInOut",
                    delay: 0.5,
                  }}
                >
                  <div className={"flex items-center gap-2 sm:gap-3"}>
                    <div
                      className={
                        "w-8 sm:w-10 h-8 sm:h-10 bg-purple-100 rounded-full flex items-center justify-center"
                      }
                    >
                      <LightbulbIcon className={"w-4 sm:w-5 h-4 sm:h-5 text-purple-600"} />
                    </div>
                    <div>
                      <p className={"text-xs text-slate-400"}>{"AI Assistance"}</p>
                      <p className={"font-medium text-xs sm:text-sm"}>{"Problem Solved"}</p>
                    </div>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className={"py-12 sm:py-16 relative z-10"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <motion.div
            className={"bg-white rounded-2xl shadow-xl overflow-hidden"}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
            variants={x}
          >
            <div className={"grid grid-cols-1 md:grid-cols-3"}>
              <div
                className={
                  "p-6 sm:p-10 border-b md:border-b-0 md:border-r border-slate-100 flex flex-col items-center text-center"
                }
              >
                <div
                  className={
                    "w-12 sm:w-16 h-12 sm:h-16 bg-indigo-50 rounded-full flex items-center justify-center mb-3 sm:mb-4"
                  }
                >
                  <CodeIcon className={"w-6 sm:w-8 h-6 sm:h-8 text-indigo-600"} />
                </div>
                <div
                  className={
                    "counter text-2xl sm:text-3xl md:text-5xl font-bold text-indigo-600 mb-1 sm:mb-2"
                  }
                >
                  {i.projects}
                  {"+"}
                </div>
                <p className={"text-xs sm:text-sm text-slate-600"}>{"Student Projects"}</p>
              </div>
              <div
                className={
                  "p-6 sm:p-10 border-b md:border-b-0 md:border-r border-slate-100 flex flex-col items-center text-center"
                }
              >
                <div
                  className={
                    "w-12 sm:w-16 h-12 sm:h-16 bg-purple-50 rounded-full flex items-center justify-center mb-3 sm:mb-4"
                  }
                >
                  <UsersIcon className={"w-6 sm:w-8 h-6 sm:h-8 text-purple-600"} />
                </div>
                <div
                  className={
                    "counter text-2xl sm:text-3xl md:text-5xl font-bold text-purple-600 mb-1 sm:mb-2"
                  }
                >
                  {i.users}
                  {"+"}
                </div>
                <p className={"text-xs sm:text-sm text-slate-600"}>{"Student Members"}</p>
              </div>
              <div className={"p-6 sm:p-10 flex flex-col items-center text-center"}>
                <div
                  className={
                    "w-12 sm:w-16 h-12 sm:h-16 bg-blue-50 rounded-full flex items-center justify-center mb-3 sm:mb-4"
                  }
                >
                  <BookOpenIcon className={"w-6 sm:w-8 h-6 sm:h-8 text-blue-600"} />
                </div>
                <div
                  className={
                    "counter text-2xl sm:text-3xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2"
                  }
                >
                  {i.completions}
                  {"+"}
                </div>
                <p className={"text-xs sm:text-sm text-slate-600"}>{"Project Completions"}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      <section className={"py-16 sm:py-20 bg-gradient-to-b from-white to-indigo-50"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <motion.div
            className={"text-center mb-12 sm:mb-16"}
            variants={x}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
          >
            <h2 className={"text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-4 text-center"}>
              {"Why Students Love Our Platform"}
            </h2>
            <p
              className={
                "text-xs sm:text-sm md:text-base text-slate-600 max-w-2xl mx-auto px-2 sm:px-4 leading-relaxed text-center"
              }
            >
              {
                "Buy ready-made academic projects with full AI-powered guidance – simple, smart, and stress-free."
              }
            </p>
          </motion.div>
          <motion.div
            className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"}
            variants={p}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
          >
            <motion.div
              className={"bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all"}
              variants={x}
            >
              <div
                className={
                  "w-12 sm:w-14 h-12 sm:h-14 bg-indigo-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6"
                }
              >
                <CodeIcon className={"w-6 sm:w-7 h-6 sm:h-7 text-indigo-600"} />
              </div>
              <h3 className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}>
                {"Ready-Made Projects"}
              </h3>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                }
              >
                {
                  "Get high-quality academic projects instantly. Perfect for final year submissions, with complete documentation and working code."
                }
              </p>
            </motion.div>
            <motion.div
              className={"bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all"}
              variants={x}
            >
              <div
                className={
                  "w-12 sm:w-14 h-12 sm:h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6"
                }
              >
                <LightbulbIcon className={"w-6 sm:w-7 h-6 sm:h-7 text-purple-600"} />
              </div>
              <h3 className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}>
                {"AI-Powered Guidance"}
              </h3>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                }
              >
                {
                  "Our built-in AI tutor explains each project – from setup to final output. Understand the code, logic, and flow easily."
                }
              </p>
            </motion.div>
            <motion.div
              className={"bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all"}
              variants={x}
            >
              <div
                className={
                  "w-12 sm:w-14 h-12 sm:h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6"
                }
              >
                <UsersIcon className={"w-6 sm:w-7 h-6 sm:h-7 text-blue-600"} />
              </div>
              <h3 className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}>
                {"Stress-Free Submissions"}
              </h3>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                }
              >
                {
                  "Save time, avoid confusion. Choose a project that fits your domain and get everything you need to present with confidence."
                }
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
      <section className={"py-16 sm:py-20 bg-white"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <motion.div
            className={"text-center mb-12 sm:mb-16"}
            variants={x}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
          >
            <h2 className={"text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-4 text-center"}>
              {"How It Works"}
            </h2>
            <p
              className={
                "text-xs sm:text-sm md:text-base text-slate-600 max-w-2xl mx-auto px-2 sm:px-4 leading-relaxed text-center"
              }
            >
              {"Buy a complete project in minutes – no stress, no confusion."}
            </p>
          </motion.div>
          <div className={"relative"}>
            <div
              className={
                "hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-indigo-100 -translate-y-1/2 z-0"
              }
            />
            <motion.div
              className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12"}
              variants={p}
              initial={"hidden"}
              whileInView={"visible"}
              viewport={{
                once: true,
              }}
            >
              <motion.div
                className={"relative z-10 flex flex-col items-center text-center"}
                variants={x}
              >
                <div
                  className={
                    "w-16 sm:w-20 h-16 sm:h-20 mb-4 sm:mb-6 rounded-full bg-white flex items-center justify-center shadow-lg border-4 border-indigo-100"
                  }
                >
                  <div
                    className={
                      "w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm sm:text-base"
                    }
                  >
                    {"1"}
                  </div>
                </div>
                <div className={"p-4 sm:p-6 bg-white rounded-xl shadow-xl"}>
                  <h3
                    className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}
                  >
                    {"Browse Projects"}
                  </h3>
                  <p
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                    }
                  >
                    {
                      "Explore a wide range of academic projects tailored to your domain and department."
                    }
                  </p>
                </div>
              </motion.div>
              <motion.div
                className={"relative z-10 flex flex-col items-center text-center lg:mt-24"}
                variants={x}
              >
                <div
                  className={
                    "w-16 sm:w-20 h-16 sm:h-20 mb-4 sm:mb-6 rounded-full bg-white flex items-center justify-center shadow-lg border-4 border-indigo-100"
                  }
                >
                  <div
                    className={
                      "w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm sm:text-base"
                    }
                  >
                    {"2"}
                  </div>
                </div>
                <div className={"p-4 sm:p-6 bg-white rounded-xl shadow-xl"}>
                  <h3
                    className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}
                  >
                    {"Select & Buy"}
                  </h3>
                  <p
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                    }
                  >
                    {
                      "Choose your project, make a secure payment, and get instant access to files and resources."
                    }
                  </p>
                </div>
              </motion.div>
              <motion.div
                className={"relative z-10 flex flex-col items-center text-center"}
                variants={x}
              >
                <div
                  className={
                    "w-16 sm:w-20 h-16 sm:h-20 mb-4 sm:mb-6 rounded-full bg-white flex items-center justify-center shadow-lg border-4 border-indigo-100"
                  }
                >
                  <div
                    className={
                      "w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm sm:text-base"
                    }
                  >
                    {"3"}
                  </div>
                </div>
                <div className={"p-4 sm:p-6 bg-white rounded-xl shadow-xl"}>
                  <h3
                    className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}
                  >
                    {"Understand with AI"}
                  </h3>
                  <p
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                    }
                  >
                    {
                      "Get AI help to understand code, logic, and presentation. Learn what you bought with ease!"
                    }
                  </p>
                </div>
              </motion.div>
              <motion.div
                className={"relative z-10 flex flex-col items-center text-center lg:mt-24"}
                variants={x}
              >
                <div
                  className={
                    "w-16 sm:w-20 h-16 sm:h-20 mb-4 sm:mb-6 rounded-full bg-white flex items-center justify-center shadow-lg border-4 border-indigo-100"
                  }
                >
                  <div
                    className={
                      "w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm sm:text-base"
                    }
                  >
                    {"4"}
                  </div>
                </div>
                <div className={"p-4 sm:p-6 bg-white rounded-xl shadow-xl"}>
                  <h3
                    className={"text-base sm:text-lg md:text-xl font-bold mb-2 sm:mb-4 text-center"}
                  >
                    {"Submit with Confidence"}
                  </h3>
                  <p
                    className={
                      "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                    }
                  >
                    {
                      "Use the complete project to present confidently in your final year review or viva."
                    }
                  </p>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className={"py-16 sm:py-20 bg-gradient-to-b from-indigo-50 to-white"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <motion.div
            className={"text-center mb-12 sm:mb-16"}
            variants={x}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
          >
            <h2 className={"text-xl sm:text-2xl md:text-3xl font-bold mb-2 sm:mb-4 text-center"}>
              {"Student Success Stories"}
            </h2>
            <p
              className={
                "text-xs sm:text-sm md:text-base text-slate-600 max-w-2xl mx-auto px-2 sm:px-4 leading-relaxed text-center"
              }
            >
              {"See how students are transforming their academic work into real opportunities"}
            </p>
          </motion.div>
          <motion.div
            className={"grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8"}
            variants={p}
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
          >
            {m.map((g) => (
              <motion.div
                key={g.id}
                className={
                  "bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all"
                }
                variants={x}
              >
                <div className={"flex items-center mb-4 sm:mb-6"}>
                  <div
                    className={
                      "w-10 sm:w-14 h-10 sm:h-14 text-white rounded-full mr-3 sm:mr-4 bg-red-400 flex justify-center items-center text-sm sm:text-base font-medium"
                    }
                  >
                    {" "}
                    {g.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className={"font-bold text-sm sm:text-base md:text-lg"}>{g.name}</h4>
                    <p className={"text-xs text-slate-600"}>
                      {g.role}
                      {", "}
                      {g.university}
                    </p>
                  </div>
                </div>
                <p
                  className={
                    "text-xs sm:text-sm md:text-base text-slate-700 italic leading-relaxed text-justify"
                  }
                >
                  {'"'}
                  {g.content}
                  {'"'}
                </p>
                <div className={"mt-4 sm:mt-6 flex"}>
                  {[1, 2, 3, 4, 5].map((b) => (
                    <StarIcon
                      key={b}
                      className={"w-4 sm:w-5 h-4 sm:h-5 text-yellow-400 fill-yellow-400"}
                    />
                  ))}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
      <section className={"py-16 sm:py-20 bg-gradient-to-b from-indigo-50 to-white"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <div className={"grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center"}>
            <motion.div
              initial={"hidden"}
              whileInView={"visible"}
              viewport={{ once: true }}
              variants={x}
            >
              <span
                className={
                  "inline-block py-1 px-3 mb-3 sm:mb-4 bg-indigo-100 text-indigo-800 rounded-full text-xs sm:text-sm font-medium"
                }
              >
                {"Included With Every Purchase"}
              </span>
              <h2 className={"text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4"}>
                {"Internship Training Program "}
                <span
                  className={
                    "bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent"
                  }
                >
                  {"Certificate"}
                </span>
              </h2>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed mb-4 sm:mb-6"
                }
              >
                {
                  "Every project you buy comes with an internship training program certificate — proof of hands-on, real-world project experience for your resume and placements."
                }
              </p>
              <ul className={"space-y-3 sm:space-y-4"}>
                <li className={"flex items-start"}>
                  <CheckIcon
                    className={"w-5 h-5 text-indigo-600 mr-2 sm:mr-3 flex-shrink-0 mt-0.5"}
                  />
                  <span className={"text-xs sm:text-sm md:text-base text-slate-700"}>
                    {"Free with every project purchase"}
                  </span>
                </li>
                <li className={"flex items-start"}>
                  <CheckIcon
                    className={"w-5 h-5 text-indigo-600 mr-2 sm:mr-3 flex-shrink-0 mt-0.5"}
                  />
                  <span className={"text-xs sm:text-sm md:text-base text-slate-700"}>
                    {"Request it directly from your purchase page"}
                  </span>
                </li>
                <li className={"flex items-start"}>
                  <CheckIcon
                    className={"w-5 h-5 text-indigo-600 mr-2 sm:mr-3 flex-shrink-0 mt-0.5"}
                  />
                  <span className={"text-xs sm:text-sm md:text-base text-slate-700"}>
                    {"Emailed to you once processed"}
                  </span>
                </li>
              </ul>
            </motion.div>
            <motion.div
              initial={"hidden"}
              whileInView={"visible"}
              viewport={{ once: true }}
              variants={x}
              className={"flex justify-center"}
            >
              <div
                className={
                  "bg-white p-6 sm:p-10 rounded-xl shadow-xl border border-indigo-100 text-center max-w-sm"
                }
              >
                <div
                  className={
                    "w-16 sm:w-20 h-16 sm:h-20 mx-auto mb-4 sm:mb-6 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center shadow-lg"
                  }
                >
                  <AwardIcon className={"w-8 sm:w-10 h-8 sm:h-10 text-white"} />
                </div>
                <h3 className={"text-base sm:text-lg md:text-xl font-bold mb-2"}>
                  {"Certificate of Internship"}
                </h3>
                <p className={"text-xs sm:text-sm text-slate-600"}>
                  {"Recognizing your project-based internship training with CodeBruh"}
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className={"py-16 sm:py-20 bg-white"}>
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <div className={"grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center"}>
            <motion.div
              initial={"hidden"}
              whileInView={"visible"}
              viewport={{
                once: true,
              }}
              variants={x}
              className={"text-center lg:text-left"}
            >
              <span
                className={
                  "inline-block py-1 px-3 sm:px-4 mb-4 sm:mb-6 bg-purple-100 text-purple-800 rounded-full font-medium text-xs sm:text-sm"
                }
              >
                {"AI-Powered Learning"}
              </span>
              <h2
                className={
                  "text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-6 text-center lg:text-left"
                }
              >
                {"Your AI-Powered Study Companion"}
              </h2>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-slate-600 mb-4 sm:mb-8 leading-relaxed text-justify"
                }
              >
                {
                  "Stuck with a project or concept? Our built-in AI assistant helps you understand how the purchased projects work, guides you through the logic, and boosts your learning with personalized support."
                }
              </p>
              <div className={"space-y-4 text-left"}>
                <div className={"flex items-start"}>
                  <div
                    className={
                      "w-10 sm:w-11 h-10 sm:h-11 bg-indigo-100 rounded-full flex items-center justify-center mt-1 mr-3 sm:mr-4 flex-shrink-0"
                    }
                  >
                    <CodeXmlIcon className={"w-4 sm:w-5 h-4 sm:h-5 text-purple-600"} />
                  </div>
                  <div>
                    <h3
                      className={"font-bold text-sm sm:text-base md:text-lg mb-1 sm:mb-2 text-left"}
                    >
                      {"Code Explainers & Debug Help"}
                    </h3>
                    <p
                      className={
                        "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                      }
                    >
                      {
                        "Learn how your purchased code works and troubleshoot with smart suggestions."
                      }
                    </p>
                  </div>
                </div>
                <div className={"flex items-start"}>
                  <div
                    className={
                      "w-10 sm:w-11 h-10 sm:h-11 bg-purple-100 rounded-full flex items-center justify-center mt-1 mr-3 sm:mr-4 flex-shrink-0"
                    }
                  >
                    <LightbulbIcon className={"w-4 sm:w-5 h-4 sm:h-5 text-purple-600"} />
                  </div>
                  <div>
                    <h3
                      className={"font-bold text-sm sm:text-base md:text-lg mb-1 sm:mb-2 text-left"}
                    >
                      {"Smart Improvement Tips"}
                    </h3>
                    <p
                      className={
                        "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                      }
                    >
                      {"Want to build on what you bought? Get ideas to expand and explore more."}
                    </p>
                  </div>
                </div>
                <div className={"flex items-start"}>
                  <div
                    className={
                      "w-10 sm:w-11 h-10 sm:h-11 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3 sm:mr-4 flex-shrink-0"
                    }
                  >
                    <BookOpenIcon className={"w-4 sm:w-5 h-4 sm:h-5 text-blue-600"} />
                  </div>
                  <div>
                    <h3
                      className={"font-bold text-sm sm:text-base md:text-lg mb-1 sm:mb-2 text-left"}
                    >
                      {"Personalized Learning Paths"}
                    </h3>
                    <p
                      className={
                        "text-xs sm:text-sm md:text-base text-slate-600 leading-relaxed text-justify"
                      }
                    >
                      {
                        "Tutorials and resources based on the project you've downloaded — no guesswork."
                      }
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={"hidden"}
              whileInView={"visible"}
              viewport={{
                once: true,
              }}
              variants={x}
              className={"relative px-4 sm:px-0"}
            >
              <div className={"bg-slate-100 rounded-xl p-4 sm:p-6 md:p-8"}>
                <div className={"bg-white rounded-lg shadow-lg overflow-hidden"}>
                  <div className={"bg-indigo-600 px-3 sm:px-4 py-2 sm:py-3 flex items-center"}>
                    <div className={"flex space-x-1 sm:space-x-2"}>
                      <div className={"w-2 sm:w-3 h-2 sm:h-3 bg-red-500 rounded-full"} />
                      <div className={"w-2 sm:w-3 h-2 sm:h-3 bg-yellow-500 rounded-full"} />
                      <div className={"w-2 sm:w-3 h-2 sm:h-3 bg-green-500 rounded-full"} />
                    </div>
                    <p className={"text-white text-xs sm:text-sm font-medium ml-3 sm:ml-4"}>
                      {"AI Assistant"}
                    </p>
                  </div>
                  <div className={"p-4 sm:p-6"}>
                    <div className={"flex items-start mb-3 sm:mb-4"}>
                      <div
                        className={
                          "w-6 sm:w-8 h-6 sm:h-8 bg-slate-200 rounded-full flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0"
                        }
                      >
                        <UsersIcon className={"w-3 sm:w-4 h-3 sm:h-4 text-slate-600"} />
                      </div>
                      <div className={"bg-slate-100 rounded-lg p-2 sm:p-3 max-w-xs"}>
                        <p className={"text-xs sm:text-sm text-slate-700"}>
                          {
                            "I'm having trouble understanding how the sorting function works in this project. Can you explain it to me?"
                          }
                        </p>
                      </div>
                    </div>
                    <div className={"flex items-start mb-3 sm:mb-4 justify-end"}>
                      <div className={"bg-indigo-100 rounded-lg p-2 sm:p-3 max-w-xs"}>
                        <p className={"text-xs sm:text-sm text-indigo-800"}>
                          {
                            "Sure! Let's break it down. The sorting function uses a quicksort algorithm that works by..."
                          }
                        </p>
                      </div>
                      <div
                        className={
                          "w-6 sm:w-8 h-6 sm:h-8 bg-indigo-200 rounded-full flex items-center justify-center ml-2 sm:ml-3 flex-shrink-0"
                        }
                      >
                        <ZapIcon className={"w-3 sm:w-4 h-3 sm:h-4 text-indigo-600"} />
                      </div>
                    </div>
                    <div className={"flex items-start mb-3 sm:mb-4"}>
                      <div
                        className={
                          "w-6 sm:w-8 h-6 sm:h-8 bg-slate-200 rounded-full flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0"
                        }
                      >
                        <UsersIcon className={"w-3 sm:w-4 h-3 sm:h-4 text-slate-600"} />
                      </div>
                      <div className={"bg-slate-100 rounded-lg p-2 sm:p-3 max-w-xs"}>
                        <p className={"text-xs sm:text-sm text-slate-700"}>
                          {
                            "Could you explain the specific logic of how quicksort handles larger inputs?"
                          }
                        </p>
                      </div>
                    </div>
                    <div className={"flex items-start justify-end"}>
                      <div className={"bg-indigo-100 rounded-lg p-2 sm:p-3 max-w-xs"}>
                        <p className={"text-xs sm:text-sm text-indigo-800"}>
                          {
                            "Sure! The quicksort algorithm works by picking a pivot and recursively sorting the sub-arrays..."
                          }
                        </p>
                      </div>
                      <div
                        className={
                          "w-6 sm:w-8 h-6 sm:h-8 bg-indigo-200 rounded-full flex items-center justify-center ml-2 sm:ml-3 flex-shrink-0"
                        }
                      >
                        <ZapIcon className={"w-3 sm:w-4 h-3 sm:h-4 text-indigo-600"} />
                      </div>
                    </div>
                    <div className={"bg-indigo-50 rounded-lg p-2 sm:p-3 mt-4 sm:mt-6"}>
                      <p className={"text-xs text-slate-500 mb-1"}>{"AI Learning Suggestions:"}</p>
                      <div className={"flex items-center gap-2 mb-1"}>
                        <BookOpenIcon className={"w-3 h-3 text-indigo-600"} />
                        <span className={"text-xs text-indigo-700"}>
                          {"QuickSort Algorithm Guide"}
                        </span>
                      </div>
                      <div className={"flex items-center gap-2 mb-1"}>
                        <CodeIcon className={"w-3 h-3 text-indigo-600"} />
                        <span className={"text-xs text-indigo-700"}>
                          {"Practice Problems: Sorting Algorithms"}
                        </span>
                      </div>
                      <div className={"flex items-center gap-2"}>
                        <ZapIcon className={"w-3 h-3 text-indigo-600"} />
                        <span className={"text-xs text-indigo-700"}>
                          {"Debug Similar Projects"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  "absolute -bottom-4 sm:-bottom-6 -right-4 sm:-right-6 w-24 sm:w-32 h-24 sm:h-32 bg-indigo-100 rounded-full opacity-50 z-0"
                }
              />
              <div
                className={
                  "absolute -top-4 sm:-top-6 -left-4 sm:-left-6 w-16 sm:w-24 h-16 sm:h-24 bg-purple-100 rounded-full opacity-50 z-0"
                }
              />
            </motion.div>
          </div>
        </div>
      </section>
      <section
        className={"py-16 sm:py-20 bg-gradient-to-r from-indigo-600 to-purple-600 text-white"}
      >
        <div className={"w-full px-4 md:px-6 lg:px-8 2xl:px-16"}>
          <motion.div
            className={
              "rounded-3xl bg-white/10 backdrop-blur-md p-8 sm:p-12 md:p-16 flex flex-col md:flex-row items-center justify-between"
            }
            initial={"hidden"}
            whileInView={"visible"}
            viewport={{
              once: true,
            }}
            variants={x}
          >
            <div className={"mb-6 sm:mb-8 md:mb-0 md:w-2/3 text-center md:text-left"}>
              <h2
                className={
                  "text-sm sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3 sm:mb-6 text-center text-nowrap md:text-left"
                }
              >
                {"Discover & Buy Quality Projects"}
              </h2>
              <p
                className={
                  "text-xs sm:text-sm md:text-base text-justify lg:text-lg text-white/90 max-w-xl mx-auto md:mx-0 mb-4 sm:mb-8 leading-relaxed  md:text-justify"
                }
              >
                {
                  "Explore a wide range of academic projects, research papers, and creative work available for purchase. Get high-quality resources to help with your studies, career, or personal projects."
                }
              </p>
              <Link to={a ? "/projects" : "/register"}>
                <Button
                  variant={"white"}
                  className={
                    "px-4 sm:px-6 py-2 sm:py-3 rounded-xl text-indigo-700 bg-gradient-to-r from-indigo-600 to-purple-600 hover:bg-gradient-to-r from-indigo-600 to-purple-600 font-medium shadow-xl hover:shadow-indigo-900/20 transition-all text-xs sm:text-sm md:text-base"
                  }
                >
                  {a ? "Browse Projects" : "Sign Up for Free"}
                </Button>
              </Link>
            </div>
            <div className={"w-full md:w-1/3 flex justify-center md:justify-end"}>
              <img
                src={navLogo}
                srcSet={`${navLogo} 400w, ${logo} 800w`}
                sizes={"(max-width: 640px) 100vw, 800px"}
                alt={"codebruh final year projects"}
                className={"rounded-2xl shadow-2xl max-w-[200px] sm:max-w-none w-full h-auto"}
                fetchPriority={"high"}
              />
            </div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export { HomePage };
